<script type="text/babel">
import ManagesModalState from "dashboard-js/mixins/ManagesModalState";
import RestoreScrollOnPageBack from "dashboard-js/mixins/RestoreScrollOnPageBack";

export default {
  mixins: [ManagesModalState, RestoreScrollOnPageBack],

  props: ["course", "user"],

  data() {
    return {
    };
  },

  computed: {},

  created() {},

  methods: {
    getDate(timestamp) {
      return moment(timestamp).format("MMMM d, yyyy");
    },
  },
};
</script>
